export const ADD_ANNOUNCEMENT = 'ADD_ANNOUNCEMENT'
export const REMOVE_ANNOUNCEMENT = 'REMOVE_ANNOUNCEMENT'
export const HIDE_ANNOUNCEMENT = 'HIDE_ANNOUNCEMENT'

export function addAnnouncement (announcement) {

  return {
    type: ADD_ANNOUNCEMENT,
    payload: announcement
  }
}

export function hideAnnouncement () {
  return {
    type: HIDE_ANNOUNCEMENT
  }
}

export function removeAnnouncement () {
  return {
    type: REMOVE_ANNOUNCEMENT
  }
}
